import React from 'react'
import { node, string, object } from 'prop-types'
import styled from 'styled-components'
import media from 'styled-media-query'

import Header from './Header'

import { white } from '../colors'

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${white};
  border: 1px solid #d6dbf0;
  box-shadow: 12px 15px 25px rgba(31, 45, 91, 0.1);
  border-radius: 6px;
`

const StyledCardContent = styled.div`
  flex: 1;
  flex-shrink: 0;
  padding: 16px 12px;
  background-color: ${white};
  border-radius: 6px;
`

const StyledFooter = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  padding: 16px 12px;

  ${media.greaterThan('medium')`
    justify-content: flex-end;
  `}
`

const Card = ({ header, content, footer, className, style, styleContent, styleFooter }) => {
  return (
    <StyledCard className={className} style={style}>
      {header}
      {content && <StyledCardContent style={styleContent}>{content}</StyledCardContent>}
      {footer && <StyledFooter style={styleFooter}>{footer}</StyledFooter>}
    </StyledCard>
  )
}

Card.propTypes = {
  header: node,
  content: node.isRequired,
  footer: node,
  className: string,
  style: object,
  styleContent: object,
  styleFooter: object
}

Card.Header = Header

export default Card
